
import { defineComponent } from 'vue';

import Hero from '@/components/Hero.vue';

export default defineComponent({
  components: { Hero },
  data() {
    return {
      hero: 'over-mij-1291614763.webp',
    };
  },
});
